function DropdownField(props: any) {
  const { options, title, editable, id, handleFieldChange, value, errors } = props;

  const handleChange = (event: any) => {
    if (value?.toString() === event.target.value) {
      handleFieldChange(id, "");
    } else {
      handleFieldChange(id, event.target.value);
    }
  };

  return (
    <div className="question_container flex flex-col w-full" id={id} style={{ maxWidth: "300px" }}>
      <div className="question_inner_container text-start">
        <label
          className="input-label block ml-1 question_title"
          dangerouslySetInnerHTML={{ __html: title }}
          style={{
            fontSize: "14px",
            fontWeight: 400,
            color: "#6B7280",
          }}
        />
      </div>

      <div className="select dropdown_container">
        <select
          className={id}
          disabled={!editable}
          id="format"
          name="format"
          onChange={handleChange}
          style={{
            ...(!editable && {
              background: "rgba(0,0,0,0.05)",
              color: "rgba(0,0,0,0.38)",
              opacity: 1,
            }),
          }}
          value={value}
        >
          <option className="blank_select_option" selected value="" />
          {options.map((option: any) => (
            <option
              className="select_option_for_dropdown"
              key={option.key}
              selected
              value={option.value}
            >
              {option.key}
            </option>
          ))}
        </select>
      </div>
      {errors && errors[id] && (
        <p className="absolute left-0" style={{ color: "red" }}>
          {errors[id]}
        </p>
      )}
    </div>
  );
}

export default DropdownField;
